<template>
    <div class="page">

        <compare-sect-new background="background-img"></compare-sect-new>
        <compare-sect-new background="background-grey"></compare-sect-new>
    </div>
</template>

<script>
    import CompareSectNew from './page-part/CompareSectNew'

    export default {
        name: "TemplateList",
        components: {
            CompareSectNew,
        },
    }
</script>

